const LogoExclamationDot = ({ className }: { className?: string }) => {
  return (
    <svg
      fill='currentColor'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 899 900'
      aria-hidden='true'
      focusable='false'
    >
      <path
        d='M449.301 900C194.943 900 .434 705 .434 450S194.943 0 449.3 0c254.358 0 448.867 195 448.867 450S703.659 900 449.301 900Z'
        fill='#F8F0E8'
      />
    </svg>
  );
};
export default LogoExclamationDot;
